<template>
    <svg v-if="type === 'filter'" class="block fill-current flex-none" width="22" height="16"><path d="m1 0c-.6 0-1 .4-1 1v2c0 .3.1.6.4.8l5.6 4.7v6.5c0 .4.2.8.6.9.1.1.3.1.4.1.3 0 .5-.1.7-.3l2-2c.2-.2.3-.4.3-.7v-4.5l5.6-4.7c.3-.2.4-.5.4-.8v-2c0-.6-.4-1-1-1z"/><path d="m19 8h-2v3h-3v2h3v3h2v-3h3v-2h-3z"/></svg>
    <svg v-else-if="type === 'location'" class="block fill-current flex-none" height="16" width="16"><path d="m8 0c-3.9 0-7 3.1-7 7 0 1.9.7 3.7 2.1 5 .1.1 4.1 3.7 4.2 3.8.4.3 1 .3 1.3 0 .1-.1 4.2-3.7 4.2-3.8 1.4-1.3 2.1-3.1 2.1-5 .1-3.9-3-7-6.9-7zm0 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>
    <svg v-else-if="type === 'type'" height="16" class="block fill-current flex-none" width="16" ><path d="m8 0c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"/><path d="m9 4h-2v5h5v-2h-3z"/></svg>
</template>

<script>
    export default {
        props: {
            type: String
        }
    }
</script>
